/* Quick add-to-cart + in-card stepper + native cart drawer, fully OPTIMISTIC.
 * Adding a product builds the new line row instantly from the product card's own data (title, image, price)
 * and renders it through the same full .drawer__inner innerHTML path the theme uses for real content -- so it
 * is guaranteed visible (no skeleton needed). The server /cart/update.js call runs in the background and the
 * real rendered drawer swaps in when it returns. Card steppers, cart count, drawer line items, line prices and
 * subtotal all stay in sync. Stutter-safe: while a newer change is queued, intermediate (stale) responses do
 * NOT touch the UI. When the cart becomes empty the drawer simply closes.
 */
(function () {
  if (window.__qacInit) return;
  window.__qacInit = true;

  var ADD_SELECTOR = 'a.qac-add';
  var desired = {};    // variantId -> intended qty
  var unitPrice = {};  // variantId -> per-unit price (cents)
  var model = {};      // variantId -> { title, image, url, unit, qty } for optimistic rendering
  var syncState = {};  // variantId -> { inFlight, pending, wantOpen }

  function root() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }
  function parseVariantId(href) { var m = (href || '').match(/[?&]add=(\d+)/); return m ? m[1] : ''; }
  function drawerEl() { return document.querySelector('cart-drawer'); }
  function cartEl() { return document.querySelector('cart-notification') || document.querySelector('cart-drawer'); }
  function inDrawer(node) { return !!(node && node.closest && node.closest('cart-drawer')); }
  function esc(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
  function sectionsToRequest(el) {
    var ids = [];
    if (el && typeof el.getSectionsToRender === 'function') { try { ids = el.getSectionsToRender().map(function (s) { return s.id; }); } catch (e) { ids = []; } }
    if (ids.indexOf('cart-icon-bubble') === -1) ids.push('cart-icon-bubble');
    if (!ids.length) ids = ['cart-drawer', 'cart-icon-bubble'];
    return ids;
  }
  function totalDesired() { var n = 0; for (var k in desired) { n += desired[k] || 0; } return n; }
  function closeDrawer() {
    var el = drawerEl(); if (!el) return;
    if (typeof el.close === 'function') { try { el.close(); return; } catch (e) {} }
    el.classList.remove('active', 'animate'); document.body.classList.remove('overflow-hidden');
  }
  function openDrawer() {
    var el = drawerEl(); if (!el) return;
    if (typeof el.open === 'function') { try { el.open(); return; } catch (e) {} }
    el.classList.add('animate', 'active'); document.body.classList.add('overflow-hidden');
  }

  /* ---- styles ---- */
  var css =
    '.qac-add{position:relative;z-index:2;}' +
    '.qac-stepper{display:flex;align-items:center;justify-content:space-between;background:#ff4db8;color:#fff;border-radius:8px;padding:4px 6px;font-size:14px;font-weight:bold;position:relative;z-index:2;}' +
    '.qac-stepper button{background:transparent;border:0;font-size:20px;line-height:1;min-width:38px;height:34px;cursor:pointer;font-weight:bold;padding:0;}' +
    '.qac-stepper button:focus{outline:2px solid rgba(255,255,255,.6);outline-offset:-2px;}' +
    '.qac-stepper .qac-qty{flex:1;text-align:center;min-width:24px;}' +
    '.qac-stepper,.qac-stepper .qac-qty,.qac-stepper button{color:#fff !important;}';
  var st = document.createElement('style'); st.id = 'qac-styles'; st.textContent = css; document.head.appendChild(st);

  /* ---- network ---- */
  function postJSON(url, body) { return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) }).then(function (r) { return r.json(); }); }
  function getCart() { return fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }

  /* ---- money ---- */
  function formatterFromSample(sample) {
    sample = (sample || '').trim(); if (!sample) return null;
    var m = sample.match(/\d[\d.,\s\u00A0]*\d|\d/); if (!m) return null;
    var num = m[0]; var idx = sample.indexOf(num);
    var prefix = sample.slice(0, idx); var suffix = sample.slice(idx + num.length);
    var decimals = 0, decSep = '.', grpSep = ',';
    var lastDot = num.lastIndexOf('.'), lastComma = num.lastIndexOf(',');
    var decPos = Math.max(lastDot, lastComma);
    if (decPos !== -1) { var after = num.length - decPos - 1; if (after === 1 || after === 2) { decimals = after; decSep = num.charAt(decPos); grpSep = decSep === '.' ? ',' : '.'; } }
    return function (cents) {
      if (typeof cents !== 'number') return sample;
      var neg = cents < 0; var fixed = (Math.abs(cents) / 100).toFixed(decimals);
      var parts = fixed.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, grpSep);
      return (neg ? '-' : '') + prefix + parts[0] + (decimals > 0 ? decSep + parts[1] : '') + suffix;
    };
  }
  function parseMoneyToCents(s) {
    s = (s || '').trim(); var m = s.match(/\d[\d.,\s\u00A0]*\d|\d/); if (!m) return null;
    var num = m[0]; var lastDot = num.lastIndexOf('.'), lastComma = num.lastIndexOf(',');
    var decPos = Math.max(lastDot, lastComma); var decSep = '', cleaned;
    if (decPos !== -1) { var after = num.length - decPos - 1; if (after === 1 || after === 2) decSep = num.charAt(decPos); }
    if (decSep) { var grp = decSep === '.' ? ',' : '.'; cleaned = num.split(grp).join('').replace(decSep, '.'); }
    else { cleaned = num.replace(/[.,\s\u00A0]/g, ''); }
    var val = parseFloat(cleaned); if (isNaN(val)) return null;
    return Math.round(val * 100);
  }
  function liveFmt() {
    var sampleEl = document.querySelector('.totals__total-value') || document.querySelector('.cart-item__price-wrapper .price') || document.querySelector('.price-item');
    return formatterFromSample(sampleEl ? sampleEl.textContent : 'Rs. 0.00') || function (c) { return 'Rs. ' + (c / 100).toFixed(2); };
  }

  /* ---- card UI ---- */
  function tagButtons() { document.querySelectorAll(ADD_SELECTOR).forEach(function (btn) { if (!btn.dataset.variantId) btn.dataset.variantId = parseVariantId(btn.getAttribute('href')); }); }
  function makeStepper(variantId) {
    var w = document.createElement('div'); w.className = 'qac-stepper'; w.setAttribute('data-variant-id', variantId);
    w.innerHTML = '<button type="button" class="qac-minus" aria-label="Decrease quantity">\u2212</button><span class="qac-qty" aria-live="polite">1</span><button type="button" class="qac-plus" aria-label="Increase quantity">+</button>';
    return w;
  }
  function stepperFor(btn, variantId) { var p = btn.parentElement; var s = p.querySelector('.qac-stepper[data-variant-id="' + variantId + '"]'); if (!s) { s = makeStepper(variantId); p.insertBefore(s, btn.nextSibling); } return s; }
  function renderButton(btn, qty) {
    var v = btn.dataset.variantId;
    if (qty > 0) { var s = stepperFor(btn, v); s.querySelector('.qac-qty').textContent = qty; s.style.display = ''; btn.style.display = 'none'; }
    else { var ex = btn.parentElement.querySelector('.qac-stepper[data-variant-id="' + v + '"]'); if (ex) ex.style.display = 'none'; btn.style.display = 'block'; }
  }
  function setVariantUI(variantId, qty) { document.querySelectorAll(ADD_SELECTOR).forEach(function (btn) { if (btn.dataset.variantId === String(variantId)) renderButton(btn, qty); }); }
  function applyMapToUI(map) { tagButtons(); document.querySelectorAll(ADD_SELECTOR).forEach(function (btn) { renderButton(btn, map[btn.dataset.variantId] || 0); }); }
  function updateCount(n) {
    document.querySelectorAll('.cart-count-bubble').forEach(function (b) {
      var s1 = b.querySelector('span[aria-hidden="true"]'); if (s1) s1.textContent = n;
      var s2 = b.querySelector('.visually-hidden'); if (s2) s2.textContent = n + (n === 1 ? ' item' : ' items');
      b.style.display = n > 0 ? '' : 'none';
    });
  }

  /* ---- card data extraction (for optimistic add) ---- */
  function cardData(btn) {
    var rootEl = btn.closest('.card-wrapper') || btn.closest('.card') || btn.closest('li') || btn.parentElement;
    var titleEl = rootEl && rootEl.querySelector('.card__heading a, .full-unstyled-link, .card__heading');
    var imgEl = rootEl && rootEl.querySelector('.card__media img, .card__inner img, img');
    var pe = rootEl && rootEl.querySelector('.price-item--sale');
    if (!pe || !/\d/.test(pe.textContent)) pe = (rootEl && (rootEl.querySelector('.price-item--regular') || rootEl.querySelector('.price-item') || rootEl.querySelector('.price')));
    var priceStr = pe ? pe.textContent.trim() : '';
    var img = '';
    if (imgEl) img = imgEl.currentSrc || imgEl.src || (imgEl.getAttribute('srcset') || '').split(' ')[0] || '';
    return { title: titleEl ? titleEl.textContent.trim() : 'Item', image: img, url: btn.getAttribute('data-product-url') || (titleEl && titleEl.getAttribute && titleEl.getAttribute('href')) || '', priceStr: priceStr };
  }

  /* ---- optimistic drawer render (full .drawer__inner) ---- */
  function modelFromCart(cart) {
    model = {};
    (cart.items || []).forEach(function (it) {
      var vid = String(it.variant_id || it.id);
      model[vid] = { title: it.product_title || it.title, image: (it.featured_image && it.featured_image.url) || it.image || '', url: it.url || '', unit: it.final_price, qty: it.quantity };
    });
  }
  function buildRow(vid, m, index, fmt) {
    var line = fmt(m.unit * m.qty); var unitTxt = fmt(m.unit);
    return '<tr id="CartDrawer-Item-' + index + '" class="cart-item" role="row">' +
      '<td class="cart-item__media" role="cell">' + (m.image ? '<img class="cart-item__image" src="' + esc(m.image) + '" alt="" loading="lazy" width="150">' : '') + '</td>' +
      '<td class="cart-item__details" role="cell"><a href="' + esc(m.url) + '" class="cart-item__name h4 break">' + esc(m.title) + '</a><div class="product-option">' + unitTxt + '</div></td>' +
      '<td class="cart-item__totals right" role="cell"><div class="cart-item__price-wrapper"><span class="price price--end">' + line + '</span></div></td>' +
      '<td class="cart-item__quantity" role="cell"><quantity-popover><div class="cart-item__quantity-wrapper quantity-popover-wrapper"><div class="quantity-popover-container"><quantity-input class="quantity cart-quantity">' +
      '<button class="quantity__button" name="minus" type="button" aria-label="Decrease"><span class="svg-wrapper">\u2212</span></button>' +
      '<input class="quantity__input" type="number" data-quantity-variant-id="' + esc(vid) + '" name="updates[]" value="' + m.qty + '" min="0" id="Drawer-quantity-' + index + '" data-index="' + index + '">' +
      '<button class="quantity__button" name="plus" type="button" aria-label="Increase"><span class="svg-wrapper">+</span></button>' +
      '</quantity-input></div><cart-remove-button id="CartDrawer-Remove-' + index + '" data-index="' + index + '"><button type="button" class="button button--tertiary cart-remove-button" aria-label="Remove" data-variant-id="' + esc(vid) + '"><span class="svg-wrapper">\u2715</span></button></cart-remove-button></div></quantity-popover></td>' +
      '</tr>';
  }
  function buildInner() {
    var el = drawerEl();
    var vids = Object.keys(model).filter(function (v) { return model[v].qty > 0; });
    var fmt = liveFmt();
    var total = 0; vids.forEach(function (v) { total += model[v].unit * model[v].qty; });
    var rows = ''; vids.forEach(function (v, i) { rows += buildRow(v, model[v], i + 1, fmt); });
    var liveHeader = el && el.querySelector('.drawer__header');
    var headerHTML = liveHeader ? liveHeader.outerHTML : '<div class="drawer__header"><h2 class="drawer__heading">Your cart</h2><button class="drawer__close" type="button" aria-label="Close"><span class="svg-wrapper">\u2715</span></button></div>';
    var itemsHTML = '<cart-drawer-items><form action="' + root() + 'cart" id="CartDrawer-Form" class="cart__contents cart-drawer__form" method="post"><div id="CartDrawer-CartItems" class="drawer__contents js-contents"><div class="drawer__cart-items-wrapper"><table class="cart-items" role="table"><tbody role="rowgroup">' + rows + '</tbody></table></div></div></form></cart-drawer-items>';
    var footerHTML = '<div class="drawer__footer"><div class="cart-drawer__footer"><div class="totals" role="status"><h2 class="totals__total">Estimated total</h2><p class="totals__total-value">' + fmt(total) + '</p></div><small class="tax-note caption-large rte">Taxes included. Discounts and shipping calculated at checkout.</small></div><div class="cart__ctas"><button type="submit" id="CartDrawer-Checkout" class="cart__checkout-button button" name="checkout" form="CartDrawer-Form">Check out</button></div></div>';
    return headerHTML + itemsHTML + footerHTML;
  }
  function renderOptimisticOpen() {
    var el = drawerEl(); if (!el) return;
    var inner = el.querySelector('.drawer__inner'); if (!inner) return;
    el.classList.remove('is-empty');
    inner.innerHTML = buildInner();
    openDrawer();
  }

  /* ---- in-place optimistic update (steps / removes on existing rows) ---- */
  function optimisticDrawer(vid, qty) {
    var el = drawerEl(); if (!el) return;
    el.querySelectorAll('.cart-item').forEach(function (row) {
      var inp = row.querySelector('[data-quantity-variant-id]');
      if (!inp || inp.getAttribute('data-quantity-variant-id') !== String(vid)) return;
      if (qty <= 0) { row.remove(); return; }
      var qi = row.querySelector('.quantity__input'); if (qi) { qi.value = qty; qi.setAttribute('value', qty); }
      var unit = unitPrice[vid] != null ? unitPrice[vid] : (model[vid] && model[vid].unit);
      var priceEl = row.querySelector('.cart-item__price-wrapper .price, .cart-item__totals .price');
      if (unit != null && priceEl) { var f = formatterFromSample(priceEl.textContent); if (f) priceEl.textContent = f(unit * qty); }
    });
    var totalEl = el.querySelector('.totals__total-value');
    if (totalEl) {
      var ft = formatterFromSample(totalEl.textContent); var sum = 0, ok = true;
      el.querySelectorAll('.cart-item').forEach(function (row) {
        var inp = row.querySelector('[data-quantity-variant-id]'); if (!inp) { ok = false; return; }
        var v = inp.getAttribute('data-quantity-variant-id'); var qi = row.querySelector('.quantity__input'); var q = qi ? parseInt(qi.value, 10) : NaN;
        var u = unitPrice[v] != null ? unitPrice[v] : (model[v] && model[v].unit);
        if (u != null && !isNaN(q)) sum += u * q; else ok = false;
      });
      if (ft && ok) totalEl.textContent = ft(sum);
    }
    if (!el.querySelector('.cart-item')) closeDrawer();
  }

  /* ---- server reconcile ---- */
  function pickInner(html, selector) { try { var d = new DOMParser().parseFromString(html, 'text/html'); var el = d.querySelector(selector); return el ? el.innerHTML : null; } catch (e) { return null; } }
  function buildUpdates(variantId, qty) { var u = {}; u[String(variantId)] = qty; return u; }
  function rowVariantId(node) { var row = node.closest && node.closest('.cart-item'); if (!row) return ''; var inp = row.querySelector('[data-quantity-variant-id]'); return inp ? inp.getAttribute('data-quantity-variant-id') : ''; }
  function currentRowQty(node) { var row = node.closest('.cart-item'); var qi = row && row.querySelector('.quantity__input'); return qi ? (parseInt(qi.value, 10) || 0) : 0; }

  function refreshBubble(cart) {
    var bubble = document.getElementById('cart-icon-bubble');
    if (cart.sections && cart.sections['cart-icon-bubble'] && bubble) { var bi = pickInner(cart.sections['cart-icon-bubble'], '#cart-icon-bubble'); if (bi != null) bubble.innerHTML = bi; }
  }
  function openCart(cart) {
    if (!(cart.item_count > 0)) { closeDrawer(); return; }
    var el = drawerEl();
    if (el && cart && cart.sections && cart.sections['cart-drawer']) {
      var fresh = pickInner(cart.sections['cart-drawer'], '.drawer__inner'); var live = el.querySelector('.drawer__inner');
      if (live && fresh != null) live.innerHTML = fresh;
      el.classList.remove('is-empty');
      var its = el.querySelector('cart-drawer-items'); if (its) its.classList.remove('is-empty');
    }
    refreshBubble(cart);
    openDrawer();
  }
  function reconcileDrawer(cart) {
    if (!(cart.item_count > 0)) { closeDrawer(); return; }
    var el = drawerEl(); if (!el) return;
    var byVid = {}; (cart.items || []).forEach(function (it) { byVid[String(it.variant_id)] = it; });
    el.querySelectorAll('.cart-item').forEach(function (row) {
      var inp = row.querySelector('[data-quantity-variant-id]'); var vid = inp && inp.getAttribute('data-quantity-variant-id'); if (!vid) return;
      var it = byVid[vid]; if (!it) { row.remove(); return; }
      var qi = row.querySelector('.quantity__input'); if (qi) { qi.value = it.quantity; qi.setAttribute('value', it.quantity); }
      var priceEl = row.querySelector('.cart-item__price-wrapper .price, .cart-item__totals .price');
      if (priceEl) { var f = formatterFromSample(priceEl.textContent); if (f) priceEl.textContent = f(it.final_line_price); }
    });
    var totalEl = el.querySelector('.totals__total-value'); if (totalEl) { var ft = formatterFromSample(totalEl.textContent); if (ft) totalEl.textContent = ft(cart.total_price); }
    el.classList.remove('is-empty');
    refreshBubble(cart);
  }
  function reconcileCardsFromCart(cart) {
    var map = {}; (cart.items || []).forEach(function (it) { var v = String(it.variant_id); map[v] = it.quantity; desired[v] = it.quantity; });
    applyMapToUI(map);
    if (typeof cart.item_count === 'number') updateCount(cart.item_count);
  }

  /* ---- coalesced server sync (stutter-safe) ---- */
  function syncVariant(variantId, openPopup) {
    var state = syncState[variantId] || (syncState[variantId] = { inFlight: false, pending: false, wantOpen: false });
    if (openPopup) state.wantOpen = true;
    if (state.inFlight) { state.pending = true; return; }
    state.inFlight = true;
    var qty = desired[variantId] || 0;
    var el = cartEl();
    postJSON(root() + 'cart/update.js', { updates: buildUpdates(variantId, qty), sections: sectionsToRequest(el), sections_url: location.pathname })
      .then(function (cart) {
        (cart.items || []).forEach(function (it) { unitPrice[String(it.variant_id)] = it.final_price; });
        if (state.pending) return; // newer change queued; let the follow-up settle the UI (prevents stutter)
        var open = state.wantOpen; state.wantOpen = false;
        if (open) openCart(cart); else reconcileDrawer(cart);
        modelFromCart(cart);
        reconcileCardsFromCart(cart);
      })
      .catch(function () {
        if (state.pending) return;
        state.wantOpen = false;
        getCart().then(function (c) { (c.items || []).forEach(function (it) { unitPrice[String(it.variant_id)] = it.final_price; }); modelFromCart(c); reconcileDrawer(c); reconcileCardsFromCart(c); }).catch(function () {});
      })
      .finally(function () { state.inFlight = false; if (state.pending) { state.pending = false; syncVariant(variantId, false); } });
  }

  /* ---- unified change ---- */
  function applyChange(vid, qty) {
    if (qty < 0) qty = 0;
    desired[vid] = qty;
    if (model[vid]) { if (qty <= 0) delete model[vid]; else model[vid].qty = qty; }
    setVariantUI(vid, qty);
    optimisticDrawer(vid, qty);
    updateCount(totalDesired());
    syncVariant(vid, false);
  }

  /* ---- actions ---- */
  function onAdd(btn) {
    var v = btn.getAttribute('data-variant-id') || parseVariantId(btn.getAttribute('href'));
    var fallback = btn.getAttribute('data-product-url');
    if (!v) { if (fallback) window.location.href = fallback; return; }
    var d = cardData(btn);
    var existing = model[v];
    var unit = existing ? existing.unit : (unitPrice[v] != null ? unitPrice[v] : parseMoneyToCents(d.priceStr));
    if (unit == null) unit = 0;
    model[v] = { title: existing ? existing.title : d.title, image: existing ? existing.image : d.image, url: existing ? existing.url : d.url, unit: unit, qty: (existing ? existing.qty : 0) + 1 };
    desired[v] = model[v].qty;
    setVariantUI(v, desired[v]);
    updateCount(totalDesired());
    renderOptimisticOpen();
    syncVariant(v, true);
  }
  function onCardStep(stepper, delta) { var v = stepper.getAttribute('data-variant-id'); var cur = (desired[v] != null) ? desired[v] : (parseInt(stepper.querySelector('.qac-qty').textContent, 10) || 0); applyChange(v, cur + delta); }
  function onDrawerQtyBtn(btn) { var plus = btn.getAttribute('name') === 'plus'; var vid = rowVariantId(btn); if (!vid) return; var cur = (desired[vid] != null) ? desired[vid] : currentRowQty(btn); applyChange(vid, cur + (plus ? 1 : -1)); }
  function onDrawerRemove(btn) { var vid = btn.getAttribute('data-variant-id') || rowVariantId(btn); if (vid) applyChange(vid, 0); }
  function onDrawerInput(inp) { var vid = inp.getAttribute('data-quantity-variant-id'); var q = parseInt(inp.value, 10); if (!vid || isNaN(q)) return; applyChange(vid, q); }

  /* ---- delegation ---- */
  document.addEventListener('click', function (e) {
    var add = e.target.closest(ADD_SELECTOR); if (add) { e.preventDefault(); e.stopPropagation(); onAdd(add); return; }
    var plus = e.target.closest('.qac-plus'); if (plus) { e.preventDefault(); onCardStep(plus.closest('.qac-stepper'), 1); return; }
    var minus = e.target.closest('.qac-minus'); if (minus) { e.preventDefault(); onCardStep(minus.closest('.qac-stepper'), -1); return; }
    var dc = e.target.closest('.drawer__close'); if (dc && inDrawer(dc)) { e.preventDefault(); closeDrawer(); return; }
    var rm = e.target.closest('.cart-remove-button'); if (rm && inDrawer(rm)) { e.preventDefault(); e.stopPropagation(); onDrawerRemove(rm); return; }
    var qb = e.target.closest('.quantity__button'); if (qb && inDrawer(qb)) { e.preventDefault(); e.stopPropagation(); onDrawerQtyBtn(qb); return; }
  }, true);
  document.addEventListener('change', function (e) { var inp = e.target.closest('.quantity__input'); if (inp && inDrawer(inp)) { e.preventDefault(); e.stopPropagation(); onDrawerInput(inp); } }, true);

  /* ---- init ---- */
  function init() {
    tagButtons();
    getCart().then(function (c) { (c.items || []).forEach(function (it) { unitPrice[String(it.variant_id)] = it.final_price; }); modelFromCart(c); reconcileCardsFromCart(c); }).catch(function () {});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
